import { useQuery } from "@apollo/client";
import { USER_DROPDOWNS } from "../../Queries";

export default (props) => {
  const { data, refetch, loading, error } = useQuery(USER_DROPDOWNS, {
    ...props,
  });
  return { data: data?.userDropdowns, loading, refetch, error };
};
